import { Button, Radio, Typography, Image } from "antd";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";

const { Text, Title } = Typography;

export const StyledContent1 = styled(Content)`
  overflow-y: hidden;
  /* flex: 0.75; */
  border-radius: 0px;
  /* border-bottom: 2px solid lightgrey; */

  @media (max-width: 1366px) {
    /* flex: 0.5; */
  }
`;

export const StyledText = styled(Text)`
  font-weight: 500;
  /* font-size: 14px; */
  font-family: "Inter";
  font-size: 13px;
  /* margin-left: 35px; */

  @media (max-width: 1366px) {
    /* Adjust to 720px resolution or lower */
    font-size: 10px;
  }

  /* @media (max-width: 1920px) {
    
  } */
`;

export const StyledButton = styled(Button)`
  font-family: "Inter";
  font-size: 13px;
  @media (max-width: 1366px) {
    /* Adjust to 720px resolution or lower */
    font-size: 8px;
  }

  /* @media (max-width: 1920px) {
    font-size: 13px;
  } */
`;

export const StyledRadio = styled(Radio)`
  font-weight: 600;
  font-family: "Inter";
  font-size: 16px;

  @media (max-width: 1366px) {
    /* Adjust to 720px resolution or lower */
    font-size: 14px;
    font-weight: 400;
  }
`;

export const StyledContent = styled(Content)`
  border-bottom: 0.5px solid grey;
  margin-bottom: 10px;
  flex: 0.081;

  @media (max-width: 1366px) {
    flex: 0.1;
  }
`;

export const StyledGenerateButton = styled(Button)`
  &&.ant-btn-primary {
    background-color: rgb(25, 34, 56);
    border-color: rgb(25, 34, 56);
    color: white;
    border-radius: 10px;
    font-family: "Inter";

    &:hover {
      background-color: white;
      border-color: #192238;
      color: #192238;
    }
    &:disabled {
      background-color: lightgray;
      border-color: lightgray;
      color: white;
    }
  }
`;

export const StyledCarousalImage = styled(Image)`
  border: 2px solid grey;
  border-radius: 5px;
  margin-top: "50px";
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

export const StyledCarousalText = styled(Text)`
  font-family: "Inter";
  margin-top: 10px;
  font-size: 18px;
  line-height: 20px;
  display: flex;
  text-align: start;
  font-weight: 650;
`;

export const StyledCarousalSubtext = styled(Text)`
  font-family: "Inter";
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  text-align: start;
  font-weight: 500;
`;

export const StyledCarousalContent = styled(Content)`
  height: 100%;
  width: auto;
`;
